import React, { FC } from 'react';
import s from './toyHistoryItem.module.scss';
import Skeleton from 'react-loading-skeleton';
interface Props {}
export const ToyHistoryItemLoader: FC<Props> = ({}) => <div className={s.toyHistoryItem} data-sentry-component="ToyHistoryItemLoader" data-sentry-source-file="ToyHistoryItemLoader.tsx">
        <div className={s.toyHistoryItem__body}>
            <Skeleton width={40} height={40} circle={true} data-sentry-element="Skeleton" data-sentry-source-file="ToyHistoryItemLoader.tsx" />
            <div className={s.toyHistoryItem__main}>
                <div className={s.toyHistoryItem__name}>
                    <Skeleton width={131} height={19} data-sentry-element="Skeleton" data-sentry-source-file="ToyHistoryItemLoader.tsx" />
                </div>
                <div className={s.toyHistoryItem__date}>
                    <Skeleton width={110} height={16} data-sentry-element="Skeleton" data-sentry-source-file="ToyHistoryItemLoader.tsx" />
                </div>
            </div>
        </div>
    </div>;